import { useState } from "react";
import "../styles/Users.scss";
import { useNavigate } from "react-router-dom";
import { createClient } from "../services/api";
import Swal from "sweetalert2";
import Select from "react-select";
import { Country, State, City } from "country-state-city";

// const isValidUrl = (url) => {
//   const trimmedUrl = url.trim();
//   if (!trimmedUrl) return false;

//   const allowedProtocols = ["http:", "https:"];

//   // Check if URL has proper format with
//   if (/:\s*$/.test(trimmedUrl)) return false;

//   try {
//     const parsedUrl = new URL(trimmedUrl);

//     // Validate protocol
//     if (!allowedProtocols.includes(parsedUrl.protocol)) return false;

//     // Check if URL ends with only the domain (no path, query, or fragment)
//     // Allow only "/" as path or empty path
//     if (parsedUrl.pathname !== "/" && parsedUrl.pathname !== "") return false;
//     if (parsedUrl.search !== "") return false; // No query parameters
//     if (parsedUrl.hash !== "") return false;   // No fragments

//     // Validate hostname: must end with dot followed by 2-4 letters only
//     // No special characters at the end
//     const hostname = parsedUrl.hostname.toLowerCase();
//     const validHostnamePattern = /^[a-z0-9.-]+\.[a-z]{2,4}$/;

//     return validHostnamePattern.test(hostname);
//   } catch (e) {
//     // If URL constructor fails, it's invalid
//     return false;
//   }
// };

const isValidUrl = (url) => {
  const trimmedUrl = url.trim();
  if (!trimmedUrl) return false;

  // Should not end with only colon or have malformed protocol
  if (/:\s*$/.test(trimmedUrl)) return false;

  const allowedProtocols = ["http:", "https:"];

  try {
    const parsedUrl = new URL(trimmedUrl);

    // Check for proper protocol
    if (!allowedProtocols.includes(parsedUrl.protocol)) return false;

    // Ensure `hostname` exists and is not part of `pathname`
    if (!parsedUrl.hostname) return false;

    // Validate hostname ends with dot and 2–4 letter TLD
    const hostname = parsedUrl.hostname.toLowerCase();
    const validHostnamePattern = /^[a-z0-9.-]+\.[a-z]{2,4}$/;
    if (!validHostnamePattern.test(hostname)) return false;

    // Only allow "/" or empty as pathname
    if (parsedUrl.pathname !== "/" && parsedUrl.pathname !== "") return false;

    // Disallow query params and fragments
    if (parsedUrl.search || parsedUrl.hash) return false;

    // Force to reject cases like "http:example.com"
    if (!trimmedUrl.startsWith("http://") && !trimmedUrl.startsWith("https://"))
      return false;

    return true;
  } catch (e) {
    return false;
  }
};

function CreateClient() {
  // For integration - fields
  const [form, setForm] = useState({
    name: "",
    website: "",
    city: "",
    country: "",
  });

  const [cityOptions, setCityOptions] = useState([]);
  const [showCityDropdown, setShowCityDropdown] = useState(false);

  const navigate = useNavigate();

  const countryOptions = Country.getAllCountries().map((country) => ({
    value: country.name, // Use name for payload
    label: country.name, // Display name in dropdown
  }));
  // Create Client
  const handleSubmit = async () => {
    if (!form.name) {
      Swal.fire({
        text: "Please provide name!",
        icon: "warning",
        showConfirmButton: false,
        heightAuto: false,
        timer: 1500,
      });
    } else if (form.name.length < 3) {
      Swal.fire({
        text: "Name should be greater than 3 characters",
        icon: "warning",
        showConfirmButton: false,
        heightAuto: false,
        timer: 1500,
      });
    } else if (form.name.length > 255) {
      Swal.fire({
        text: "Name should be less than 255 characters",
        icon: "warning",
        showConfirmButton: false,
        heightAuto: false,
        timer: 1500,
      });
    } else if (!form.website) {
      Swal.fire({
        text: "Please provide website!",
        icon: "warning",
        showConfirmButton: false,
        heightAuto: false,
        timer: 1500,
      });
    } else if (form.website.length > 255) {
      Swal.fire({
        text: "Website should be less than 255 characters",
        icon: "warning",
        showConfirmButton: false,
        heightAuto: false,
        timer: 1500,
      });
    } else if (!isValidUrl(form.website)) {
      Swal.fire({
        text: "Please enter a valid website URL!",
        icon: "warning",
        showConfirmButton: false,
        timer: 1500,
      });
    } else if (!form.city) {
      return Swal.fire({
        text: "Please provide city!",
        icon: "warning",
        showConfirmButton: false,
        heightAuto: false,
        timer: 1500,
      });
    } else if (!form.country) {
      return Swal.fire({
        text: "Please select a country!",
        icon: "warning",
        showConfirmButton: false,
        heightAuto: false,
        timer: 1500,
      });
    } else {
      const payload = {
        name: form.name.trim(),
        website: form.website.trim(),
        city: form.city.trim(),
        country: form.country.trim(),
      };
      //   console.log(payload);
      //   return;
      Swal.fire({
        html: `<img src=${require("../assets/loader.gif")} style="width: 50px" alt="loader">`,
        showConfirmButton: false,
        heightAuto: false,
        customClass: { popup: "loader-swal" },
        allowOutsideClick: false,
      });

      let apiData = await createClient({ ...payload });
      Swal.close();
      console.log(apiData);
      if (apiData.status === "S") {
        Swal.fire({
          text: "Client created successfully",
          showConfirmButton: false,
          icon: "success",
          timer: 3000,
        }).then(() => {
          navigate("/clients");
        });
      }
      // if (apiData.status === "E" && apiData.status_code === "300") {
      //     Swal.fire({
      //     text: "Email is already taken",
      //     showConfirmButton: false,
      //     icon: "warning",
      //     timer: 3000,
      //     });
      // }
      // if (apiData.status === "E" && apiData.status_code === "302") {
      //     Swal.fire({
      //     text: "License limit exceeded!",
      //     showConfirmButton: false,
      //     icon: "warning",
      //     timer: 3000,
      //     });
      // }
      else if (apiData.status === "E") {
        Swal.fire({
          text: apiData.message,
          showConfirmButton: false,
          icon: "warning",
          timer: 3000,
        });
      }
      if (
        apiData.status === "F" &&
        apiData.message === "Unauthorized - Missing token"
      ) {
        Swal.fire({
          text: "Please login with your credentials",
          icon: "warning",
          showConfirmButton: false,
          timer: 3000,
        }).then(() => {
          localStorage.clear();
          navigate("/login");
        });
      }
      if (
        apiData.status === "F" &&
        apiData.message === "Unauthorized - Invalid token"
      ) {
        Swal.fire({
          text: "Please login with your credentials",
          icon: "warning",
          showConfirmButton: false,
          timer: 3000,
        }).then(() => {
          localStorage.clear();
          navigate("/login");
        });
      }
    }
  };

  // Function to handle country change and update city field accordingly
  const handleCountryChange = (selected) => {
    const countryName = selected ? selected.value : "";
    setForm((f) => ({
      ...f,
      country: countryName,
      city: "", // Reset city when country changes
    }));

    // Check if India is selected
    if (countryName === "India") {
      setShowCityDropdown(true);
      // Get all states of India
      const indiaCountry = Country.getAllCountries().find(
        (c) => c.name === "India"
      );
      if (indiaCountry) {
        const states = State.getStatesOfCountry(indiaCountry.isoCode);
        const allCities = [];

        // Get cities from all states
        states.forEach((state) => {
          const cities = City.getCitiesOfState(
            indiaCountry.isoCode,
            state.isoCode
          );
          cities.forEach((city) => {
            allCities.push({
              value: city.name,
              label: `${city.name}`,
            });
          });
        });

        // Remove duplicates and sort
        const uniqueCities = allCities
          .filter(
            (city, index, self) =>
              index === self.findIndex((c) => c.value === city.value)
          )
          .sort((a, b) => a.label.localeCompare(b.label));

        setCityOptions(uniqueCities);
      }
    } else {
      setShowCityDropdown(false);
      setCityOptions([]);
    }
  };

  return (
    <div className="users-page">
      <div className="user-create-container">
        <h2 style={{ fontWeight: 600, fontSize: "1.3rem" }}>Create Client</h2>
        <div className="user-create-form">
          <div className="user-section">
            <div className="user-section-title">Client Details</div>
            <div className="user-row">
              <div className="user-field" style={{ minWidth: 0 }}>
                <label>Name *</label>
                <input
                  name="name"
                  value={form.name}
                  onChange={(ev) => {
                    const value = ev.target.value;
                    // Don't allow if it doesn't start with a letter (but allow empty string)
                    if (value !== "" && !/^[a-zA-Z]/.test(value)) {
                      return; // Reject if doesn't start with letter
                    }
                    const invalidPattern =
                      /<script.*?>.*?<\/script>|[<>\\{}=:/""'']/i;
                    if (!invalidPattern.test(value)) {
                      setForm({ ...form, name: value });
                    }
                  }}
                  required
                  placeholder="Enter full name"
                  className="custom-placeholder"
                  autoComplete="off"
                />
              </div>
              <div className="user-field" style={{ minWidth: 0 }}>
                <label htmlFor="text">Website *</label>
                <input
                  id="website"
                  name="website"
                  type="text"
                  value={form.website}
                  onChange={(ev) => {
                    const value = ev.target.value;
                    const invalidPattern =
                      /<script.*?>.*?<\/script>|[<>\\{}=""''\s]/i;

                    // Always allow input if it's not malicious
                    if (!invalidPattern.test(value)) {
                      setForm({ ...form, website: value });
                    }
                  }}
                  required
                  placeholder="Enter company website"
                  className="custom-placeholder"
                  autoComplete="off"
                />
              </div>
            </div>
            <div className="user-row">
              <div className="user-field">
                <label>Country *</label>
                <Select
                  options={countryOptions}
                  value={
                    countryOptions.find((opt) => opt.value === form.country) ||
                    null
                  }
                  onChange={handleCountryChange}
                  placeholder="Select Country"
                  isSearchable={true}
                  classNamePrefix="react-select"
                  styles={{
                    control: (base) => ({
                      ...base,
                      padding: "0.15rem 0.3rem", // ✅ This adds padding inside the input box
                      //   minHeight: "40px", // optional for better height control
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 9999, // ✅ Keep this for dropdown visibility
                    }),
                  }}
                  isClearable
                />
              </div>
              <div className="user-field" style={{ minWidth: 0 }}>
                <label>City *</label>
                {showCityDropdown ? (
                  <Select
                    options={cityOptions}
                    value={
                      cityOptions.find((opt) => opt.value === form.city) || null
                    }
                    onChange={(selected) =>
                      setForm((f) => ({
                        ...f,
                        city: selected ? selected.value : "",
                      }))
                    }
                    placeholder="Select City"
                    isSearchable={true}
                    classNamePrefix="react-select"
                    styles={{
                      control: (base) => ({
                        ...base,
                        padding: "0.15rem 0.3rem",
                      }),
                      menu: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }),
                    }}
                    isClearable
                  />
                ) : (
                  <input
                    name="city"
                    value={form.city}
                    onChange={(ev) => {
                      const value = ev.target.value;
                      // Don't allow if it doesn't start with a letter (but allow empty string)
                      if (value !== "" && !/^[a-zA-Z]/.test(value)) {
                        return; // Reject if doesn't start with letter
                      }
                      const invalidPattern =
                        /<script.*?>.*?<\/script>|[<>\\{}=:/""'']/i;
                      if (!invalidPattern.test(value)) {
                        setForm({ ...form, city: value });
                      }
                    }}
                    placeholder="Enter city"
                    className="custom-placeholder"
                    autoComplete="off"
                  />
                )}
              </div>
            </div>
          </div>

          <div className="user-actions justify-content-center">
            <button
              className="cancel-btn"
              type="button"
              onClick={() => navigate("/clients")}
            >
              Cancel
            </button>
            <button className="save-btn" onClick={handleSubmit}>
              Create
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateClient;
